var _defs, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.979 64.225",
    preserveAspectRatio: "xMinYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2db3a5;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,158.869l21.616-11.507L11.507,137.25Z",
    transform: "translate(0 -96.44)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 32.112,
    cy: 32.112,
    r: 32.112,
    transform: "translate(1.347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M228.45,113.848c0-6.348,4.311-10.008,9.06-10.008s9.06,3.66,9.06,10.008-4.311,9.976-9.06,9.976S228.45,120.161,228.45,113.848Zm13.529,0c0-3.818-1.677-6.363-4.46-6.363s-4.46,2.545-4.46,6.363,1.677,6.33,4.46,6.33,4.475-2.515,4.475-6.33Z",
    transform: "translate(-160.523 -72.965)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M297.245,105.755V96.678H294.53V93.327l2.95-.2.526-5.2h3.708v5.2h4.85v3.55h-4.85v9.069c0,2.242.868,3.345,2.7,3.345a5.989,5.989,0,0,0,1.986-.434l.758,3.289a12.316,12.316,0,0,1-3.892.7C298.874,112.645,297.245,109.868,297.245,105.755Z",
    transform: "translate(-206.955 -61.785)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M346.79,79.707a2.771,2.771,0,1,1,2.759,2.53A2.556,2.556,0,0,1,346.79,79.707Zm.511,5.866h4.46v19.05H347.3Z",
    transform: "translate(-243.676 -54.232)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.63,84.789l2.792-.2h7.96v3.55H376.63Zm2.56-2.171c0-3.949,1.814-6.839,6.315-6.839a9.68,9.68,0,0,1,3.491.66l-.853,3.336a5.353,5.353,0,0,0-2.064-.449c-1.585,0-2.42,1-2.42,3.211v21.111H379.2Z",
    transform: "translate(-264.644 -53.248)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M417.2,131.894l.821-3.461a5.353,5.353,0,0,0,1.368.265c2,0,3.164-1.368,3.8-3.271l.357-1.189-7.493-18.818h4.528l3.292,9.339c.574,1.689,1.115,3.568,1.674,5.382h.155c.482-1.769.963-3.645,1.46-5.382l2.851-9.348h4.311l-6.889,19.922c-1.582,4.291-3.583,6.952-7.731,6.952A7.463,7.463,0,0,1,417.2,131.894Z",
    transform: "translate(-292.343 -74.068)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.5,50.75h9.693l7.93,15.97,3.416,8.043h.22A128.925,128.925,0,0,1,81.546,61.1V50.75H90.58v35.8H80.886L72.947,70.523,69.54,62.536h-.22a134.072,134.072,0,0,1,1.213,13.657V86.549H61.5Z",
    transform: "translate(-43.214 -35.66)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyLogo);
export default __webpack_public_path__ + "static/media/Notify_Logo.68ca025b1c223d120c60a1d1278eebaa.svg";
export { ForwardRef as ReactComponent };